exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".Header {\n  padding: 25px 15px 0;\n  max-width: 430px;\n  margin: 0 0 25px;\n  width: 100%; }\n  @media only screen and (min-width: 400px) {\n    .Header {\n      margin-left: auto;\n      margin-right: auto;\n      max-width: 680px; } }\n\n.Header__date {\n  color: #ebff66;\n  text-align: center;\n  font-weight: bold;\n  margin-bottom: 15px; }\n\n.Header__logos {\n  text-align: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader/lib!./~/sass-loader/lib/loader.js!./app/src/scss/Header.scss
// module id = 265
// module chunks = 0